import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import InputField from 'components/Input-Field/input-field';
import { TableCell, TableHead, CardContent, Card, Divider } from '@mui/material';
import Grid from '@mui/material/Grid';
import TableRow from '@mui/material/TableRow';

// 🌐 Global styles (move this to Theme if needed)
export const GlobalStyle = styled('div')({
  '*': {
    boxSizing: 'border-box',
    margin: 0,
    padding: 0,
  },
});

// 🧱 Layout Components
export const GridFullWidth = styled(Grid)({
  width: '100%',
  margin: 0,
});

export const RootContainer = styled(Card)({
  paddingLeft: 8,
  paddingRight: 8,
});

export const CardContentStyled = styled(Box)({
  display: 'flex',
  padding: 8,
  '&:last-child': {
    paddingBottom: 12,
  },
});

// 🟧 Status-based Cards
export const ActiveCardItem = styled(Box)({
  color: '#ff9100',
  backgroundColor: '#ff9100',
});

export const StatusOpen = styled(Box)({
  backgroundColor: 'blue',
  color: 'white',
});

export const StatusProgress = styled(Box)({
  backgroundColor: 'orange',
  color: 'white',
});

export const StatusYard = styled(Box)({
  backgroundColor: 'red',
  color: 'white',
});

export const StatusComplete = styled(Box)({
  backgroundColor: 'green',
  color: 'white',
});

export const StatusInvoiced = styled(Box)({
  backgroundColor: 'green',
  color: 'white',
});

export const IsSelected = styled(Box)({
  backgroundColor: '#2196f373',
});

// 📦 File Upload & Row Styles
export const FileDataRow = styled(Box)({
  '&:hover': {
    cursor: 'pointer',
  },
});

export const FileDesc = styled(InputField)({
  marginTop: 0,
  marginBottom: 0,
  width: '75%',
  height: 'auto',
});

export const FileUploadBtn = styled(Button)({
  marginLeft: 5,
  marginRight: 0,
  height: 35,
});

export const FileUploadBtnFit = styled(Button)({
  marginLeft: 5,
  minWidth: 'fit-content',
  marginRight: 0,
  height: 35,
});

export const FileUploadSelectBtn = styled(Button)({
  height: 35,
});

// 📋 Table Styles

export const FileDataRowStyled = styled(TableRow)(({ theme, selected }) => ({
  '&:hover': {
    cursor: 'pointer',
  },
  ...(selected && {
    backgroundColor: '#2196f373', // isSelected color
  }),
}));

export const StyledTable = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
});

export const TableRowStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
});

export const TableRowColumn = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flexBasis: '100%',
});

export const TableCellStyled = styled(Box)({
  flex: 1,
  alignContent: 'center',
});

export const TableHeader = styled(TableHead)({
  backgroundColor: '#f0f0f0',
});

export const TableHeaderRow = styled(TableRow)({
  backgroundColor: '#f0f0f0',
});

export const TableHeaderCell = styled(TableCell)({
  color: '#000',
  fontWeight: 900,
});

export const TableCellContent = styled(TableCell)({
  color: '#000',
  fontSize: 12,
});

// 🖱️ Buttons
export const ActionIconButton = styled(IconButton)(({ theme }) => ({
  padding: 4,
  color: theme.palette.primary.main,
}));

export const ActionButton = styled(Button)({
  height: 35,
  minWidth: 'fit-content',
  marginLeft: 10,
  marginRight: 10,
});

// 🧾 Miscellaneous
export const CustomPaymentTextBox = styled(Box)({
  minWidth: 75,
});

export const ActionLink = styled(Box)({
  color: '#2196F3',
  '&:hover': {
    cursor: 'pointer',
  },
});

export const FormattedData = styled(Typography)({
  textDecoration: 'underline dotted',
  letterSpacing: 1,
});

export const OverflowText = styled('span')({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
});

export const OverflowTextTypography = styled(Typography)({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
});

// 🏊 Swimlane
export const SwimlaneBox = styled(CardContent)({
  width: '100%',
  overflow: 'hidden',
  backgroundColor: '#fafafa',
  minHeight: '200px',
  maxHeight: 0,
  overflowY: 'auto',
});

export const SwimlaneBoxDivider = styled(Divider)({
  backgroundImage:
    'linear-gradient(90deg, hsl(0deg 0% 80%), hsl(0deg 0% 60%), hsl(0deg 0% 80%))',
});

export const SwimlaneHeader = styled(Typography)({
  borderBottom: '',
});

// Layout cells with flex ratios
export const CellC1 = styled(Box)({
  flex: 1,
  display: 'flex',
  flexBasis: '90%',
});

export const CellC2 = styled(Box)({
  flex: 1,
  display: 'flex',
  flexBasis: '10%',
});
